module.exports = __webpack_public_path__ + "img/dred_envelopese.f8d1a438.png";